// Clamps a value between a minimum and maximum value (default 0, and 1 respectively)
export const clamp = (value: number, min = 0, max = 1) => Math.min(Math.max(value, min), max)
